import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

interface VehicleListTitleProps {
  dataLength: number;
  title: string;
  breadcrumbs?: string;
  wrapperClasses?: string;
}

const VehicleListTitle: FunctionComponent<VehicleListTitleProps> = ({
  dataLength,
  title,
  breadcrumbs,
  wrapperClasses,
}) => {
  const { t } = useTranslation('search');
  return (
    <div className={wrapperClasses}>
      {breadcrumbs}
      <h1 className="text-xl">{title}</h1>
      <h2 className="mt-1 text-18px text-slate-500">
        {t('subTitle', { title })}
      </h2>
      <div className="mt-2 text-sm text-slate-500">
        {t('itemsFound', { count: dataLength })}
      </div>
    </div>
  );
};

export default VehicleListTitle;
